const afterCellChanged = changes => changes;

export default afterCellChanged;
